import { render, staticRenderFns } from "./bwtemplateBuilder.vue?vue&type=template&id=25d63841&"
import script from "./bwtemplateBuilder.vue?vue&type=script&lang=js&"
export * from "./bwtemplateBuilder.vue?vue&type=script&lang=js&"
import style0 from "./bwtemplateBuilder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports